import React from 'react';
import { motion } from 'framer-motion';
export function FalseBelief() {
  return <section className="py-28 px-4 bg-dark-800 border-y border-white/5" data-id="element-12">
      <div className="max-w-4xl mx-auto text-center" data-id="element-13">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-amber-gold font-bold tracking-wider uppercase text-sm mb-8" data-id="element-14">
          La mentira más cara que te has creído
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-15">
          <h3 className="text-3xl md:text-5xl font-bold text-gray-500 line-through decoration-amber-600/50 decoration-4 mb-6" data-id="element-16">
            "Cuando me sienta listo… empiezo."
          </h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-17">
            Eso suena razonable. Hasta que lo repites por meses.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-dark-900 inline-block p-8 rounded-xl border border-amber-gold/20 shadow-glow-amber" data-id="element-18">
          <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-19">
            La confianza no llega antes. <br data-id="element-20" />
            <span className="text-amber-500 text-glow-amber" data-id="element-21">
              Llega después.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}